import type { MatchesById } from 'app/lib/betting/betting-entities/reducers/matches/types';

import type { StageWithHierarchy } from 'app/redux/betting-presentation/grid/selectors/allSportsGrid';

import {
  getFilteredMatchesByTimeFilter,
  MatchesBySportId,
} from './get-filtered-matches-by-time-filter';
import { timeFilterValueProcessing } from './time-filter-value-processing';

type GetFilteredTournamentsByTimeFilterProps = {
  matches?: MatchesById;
  stages: Map<number, StageWithHierarchy>;
  timeFilterValue: string;
  filteredMatches?: MatchesBySportId;
};

export const getFilteredTournamentsByTimeFilter = ({
  matches,
  filteredMatches,
  stages,
  timeFilterValue,
}: GetFilteredTournamentsByTimeFilterProps) => {
  const {
    timeFilterValueNumber,
    isValidTimeFilterValue,
  } = timeFilterValueProcessing(timeFilterValue);

  if (!isValidTimeFilterValue) {
    return stages;
  }

  const filteredMatchesByStartDate =
    filteredMatches
    || matches && getFilteredMatchesByTimeFilter(matches, timeFilterValueNumber);

  if (!filteredMatchesByStartDate) {
    return stages;
  }

  const filteredTournamentsById = new Map();

  stages.forEach((stage) => {
    const filteredMatchesForCurrentSportId = filteredMatchesByStartDate[stage.sportId];

    if (!filteredMatchesForCurrentSportId) {
      return false;
    }

    const filteredMatchIds = new Set<number>();

    stage.matchIds.forEach((matchId) => {
      if (filteredMatchesForCurrentSportId.has(matchId)) {
        filteredMatchIds.add(matchId);
      }
    });

    if (filteredMatchIds.size === 0) {
      return false;
    }

    filteredTournamentsById.set(stage.id, {
      ...stage,
      matchIds: filteredMatchIds,
    });
  });

  // const filteredTournamentsById = tournaments.filter((tournament) => {
  //   const filteredMatchesForCurrentSportId = filteredMatchesByStartDate[tournament.sportId];
  //
  //   if (!filteredMatchesForCurrentSportId) {
  //     return false;
  //   }
  //
  //   const filteredMatchIds = new Set<number>();
  //
  //   tournament.matchIds.forEach((matchId) => {
  //     if (filteredMatchesForCurrentSportId.has(matchId)) {
  //       filteredMatchIds.add(matchId);
  //     }
  //   });
  //
  //   if (filteredMatchIds.size === 0) {
  //     return false;
  //   }
  //
  //   tournament.set('matchIds', filteredMatchIds);
  //
  //   return true;
  // });

  return filteredTournamentsById;
};
